/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VendorNoticeDto } from '../../models/vendor-notice-dto';

export interface VendorNoticeControllerFindAll$Params {
}

export function vendorNoticeControllerFindAll(http: HttpClient, rootUrl: string, params?: VendorNoticeControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<VendorNoticeDto>>> {
  const rb = new RequestBuilder(rootUrl, vendorNoticeControllerFindAll.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<VendorNoticeDto>>;
    })
  );
}

vendorNoticeControllerFindAll.PATH = '/api/vendor-notice';
